import { ISuggestionsState } from '../../types/redux/suggestions';

export const DEFAULT_SUGGESTIONS_STATE: ISuggestionsState = {
  error: false,
  list: null,
};
